import { Tabs } from "antd";
import React, { useState, useEffect, useContext } from "react";
import { IoMdAddCircleOutline } from "react-icons/io";
// import CarDetails from "./CarDetails";
import "./carform.scss";
import moment from "moment";
import {
  fetchBrands,
  fetchCarDetails,
  fetchCities,
  fetchModels,
  fetchDistricts,
  fetchPackages,
} from "../../stores/api_calls/carlists";
import UploadCarImages from "./UploadCarImages";
import PreviewCar from "./PreviewCar";
import { useLocation } from "react-router-dom";
import Kjur from "../../stores/utils/jwt";
import {
  validateProductForm,
  validateNewProductForm,
  validateUpload,
} from "../../stores/helpers/productFormValidation";
import {
  fuelTypes,
  newCarConditions,
  ownerIdTypes,
  vehicleTypes,
  newCarVehicleTypes,
} from "../../contants/variables";
import { fetchUsers } from "../../stores/api_calls/users";
import { AccessContext } from "../../stores/contexts/accessContext";
import NewCarDetails from "./NewCarDetails";
import Specifications from "./Specifications";
import Equipments from "./Equipments";
import PreviewNewCar from "./PreviewNewCar";
import { convertToRaw } from "draft-js";

const { TabPane } = Tabs;

const NewCarFormIndex = (props) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const [isEdit, setIsEdit] = useState(false);
  // const [roles,permissions] = useContext(AccessContext)
  const [cities, setCities] = useState({ loading: false, data: [] });
  const [districts, setDistricts] = useState({ loading: false, data: [] });
  const [brands, setBrands] = useState({ loading: false, data: [] });
  const [dealers, setDealers] = useState({ loading: false, data: [] });
  const [packages, setPackages] = useState([]);
  const [models, setModels] = useState({ loading: false, data: [] });
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [urlsHolder, setUrlsHolder] = useState([]);
  const [saleAdvisers, setSaleAdvisers] = useState([]);
  const [form, setForm] = useState({
    dealerId: ``,
    dealerFirstName: "",
    dealerLastName: "",
    dealerMobileNumber: "",
    dealerEmail: "",
    direct_seller: false,
    role: "",
    displayMobile: 0,
    enableInquiry: 0,
    packageId: "",
    isManualInput: 0,
    city: "",
    district: "",
    carName: "",
    askingPrice: 0,
    monthly_installment_price: 0,
    roadTax: 0,
    carBrand: "",
    carModel: "",
    vehicleType: "",
    registrationDate: moment(),
    manufacturedYear: "",
    color: "",
    mileage: "",
    numberOfOwners: "",
    option_label_1: "",
    youtubeVideo: "",
    tiktokVideo: "",
    videoType: "youtube",
    localVideoUrl: null,
    isVerified: false,
    isSendEmail: false,
    productAgents: [],

    cityId: "",
    cityName: "",
    regionName: "",
    address: "",

    features: "",
    accessories: "",
    description: "",

    transmission: "",
    fuelType: "",
    engineCap: "",
    power: "",
    curbWeight: "",
    driveRange: 0,
    fuelConsumptionKilometer: 0,
    isHybrid: false,
    isElectric: false,

    condition: "New",
    new_condition: "",
    newCategory: "",
    isRental: false,
    imageUrls: [],

    builtIn: "",
    launchYear: "",
    featFormatted: "",
    acceFormatted: "",
    descFormatted: "",
    brochures: "",
    longAdImage1: "",

    specifications: [],
    equipments: [],

    // plateNumber: "",
    // ownerIdType: "",
    // ownerId: "",
    // omv: "",
    // arf: "",
    // coe: "",
    // coeExpiryDate: moment(),
    // isOffPeak: false,
    // offPeakOption: 0,
    // vehicleNumber: "",
    // vehicleUnitNumber: "",
    // vehicleReferenceNumber: "",
    // vehicleRegistrationCardNumber: "",
    // deregValue: "",
    // depreciationValue: "",
    // noOfBidding: "",
  });
  const [enableTab, setEnableTab] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedFile1, setSelectedFile1] = useState({ file: null, url: "" });
  // const [selectedFile2, setSelectedFile2] = useState({ file: null, url: "" });

  // useEffect(() => {
  //   if (form) {
  //     const value = validateProductForm(form);
  //     if (value) {
  //       setEnableTab(1);
  //     } else {
  //       setEnableTab(0);
  //     }
  //   }
  // }, [form]);

  // useEffect(() => {
  //   if ((selectedFiles || form.imageUrls) && enableTab === 1) {
  //     const value = validateUpload(selectedFiles, form.imageUrls);
  //     if (value) {
  //       setEnableTab(2);
  //     } else {
  //       setEnableTab(1);
  //     }
  //   }
  // }, [selectedFiles, form.imageUrls, enableTab]);

  useEffect(() => {
    getCities();
    getBrands();
    getPackages();
    getDealers();

    if (location.pathname.includes("/edit")) {
      setIsEdit(true);
    }
  }, []);

  useEffect(() => {
    if (isEdit) {
      getCarDetails();
    }
  }, [isEdit]);

  useEffect(() => {
    // if (form.carBrand && !isEdit) {
    //   setModels({ ...models, loading: true, data: [] });
    //   setForm({ ...form, carModel: "" });
    //   getModels();
    // } else if (form.carBrand && isEdit) {
    //   getModels();
    // }
    if (form.carBrand) {
      setModels({ ...models, loading: true, data: [] });
      //setForm({ ...form, carModel: "" });
      getModels();
    } else {
      setModels({ ...models, loading: false, data: [] });
      setForm({ ...form, carModel: "" });
    }
  }, [form.carBrand]);
  useEffect(() => {
    if (form.city) {
      // console.log(form.carBrand, form.carModel);
      setDistricts({ ...districts, loading: true, data: [] });
      // setForm({ ...form, carModel: "" });
      getDistricts();
    } else {
      setModels({ ...districts, loading: false, data: [] });
      setForm({ ...form, district: "" });
    }
  }, [form.city]);

  useEffect(() => {
    if (!form.isOffPeak) {
      setForm({ ...form, offPeakOption: 0 });
    }
  }, [form.isOffPeak]);

  // console.log(dealers)

  useEffect(() => {
    if (!form.dealerId || !dealers?.data?.length) return;

    const dealer = dealers.data.find((d) => d._id === form.dealerId);

    if (!dealer) return;

    setForm((prev) => ({
      ...prev,
      dealerMobileNumber: dealer.user_contact_numbers
        ?.filter((el) => el.is_active)
        .map((el) => el.number),

      dealerEmail: dealer.user_contact_emails
        ?.filter((el) => el.is_active)
        .map((el) => el.email),

      role: dealer.user_role,
    }));
  }, [form.dealerId, dealers.data]);

  const getCarDetails = async () => {
    setIsLoading(true);
    const onGetCarDetails = fetchCarDetails(params.get("id"));
    onGetCarDetails
      .then((res) => {
        if (res.data.success) {
          const parsedData = res.data.data;
          // console.log("Api Data: ", parsedData);

          setForm({
            ...form,
            id: parsedData._id,
            packageId: parsedData.selected_ads_id,

            dealerId: parsedData.advertisement_contact_details?._id ?? "",
            role:
              parsedData.advertisement_contact_details?.role_name ?? "Dealer",
            dealerEmail:
              parsedData.advertisement_contact_details?.user_contact_emails
                ?.email,
            dealerMobileNumber:
              parsedData.advertisement_contact_details?.user_contact_numbers
                ?.number,
            fullname: parsedData.advertisement_contact_details?.name,
            direct_seller:
              parsedData.advertisement_contact_details?.direct_seller,

            carName: parsedData.product_name,
            askingPrice: parsedData.product_price,
            monthly_installment_price:
              parsedData.monthly_installment_price ?? 0,
            roadTax: parsedData.road_tax,
            carBrand: parsedData.product_brand?._id ?? "",
            carModel: parsedData.product_brand_model?._id ?? "",
            vehicleType: parsedData.vehicle_type,
            manufacturedYear: parsedData.product_edition,
            color: parsedData.color,
            mileage: parsedData.product_mileage,
            numberOfOwners: parsedData.number_of_owners,
            option_label_1: parsedData.option_label_1
              ? parsedData.option_label_1
              : null,
            youtubeVideo: parsedData.youtube_video,
            tiktokVideo: parsedData.tiktok_video,
            videoType:
              parsedData?.video_type != null
                ? parsedData?.video_type
                : "youtube",
            localVideoUrl: parsedData?.local_video_url,
            productAgents: parsedData?.product_agents ?? [],
            city: parsedData.city?._id ?? "",
            district: parsedData.district?._id ?? "",
            features: parsedData.vehicle_features ?? ".",
            accessories: parsedData.accessories ?? ".",
            description: parsedData.product_description ?? ".",

            transmission: parsedData.product_transmission,
            fuelType: parsedData.fuel_type,
            engineCap: parsedData.product_cc,
            power: parsedData.power,
            curbWeight: parsedData.curb_weight,
            driveRange: parsedData?.drive_range ?? 0,
            fuelConsumptionKilometer:
              parsedData?.fuel_consumption_kilometer ?? 0,
            isHybrid: parsedData.is_hybrid,
            isElectric: parsedData.is_electric,

            condition: parsedData.product_condition,
            new_condition: parsedData.new_condition ?? "New",
            newCategory: parsedData.new_category,
            isRental: parsedData.product_is_rental,
            imageUrls: parsedData.product_image_urls,

            builtIn: parsedData.built_in,
            launchYear: parsedData.product_edition,
            featFormatted:
              parsedData.features_formatted ?? parsedData.vehicle_features,
            acceFormatted:
              parsedData.accessories_formatted ?? parsedData.accessories,
            descFormatted:
              parsedData.description_formatted ??
              parsedData.product_description,
            brochures: parsedData.brochures,
            longAdImage1: parsedData.long_ad_image_1
              ? parsedData?.long_ad_image_1
              : "",

            specifications: parsedData.specifications,
            equipments: parsedData.equipments,

            // plateNumber: parsedData.car_plate_number,
            // isVerified: parsedData.is_verified,
            // isSendEmail: parsedData.is_send_email ?? false,
            // descriptionFormatted: parsedData.description_formatted,
            // featuresFormatted: parsedData.features_formatted,
            // acccessoriesFormatted: parsedData.accessories_formatted,
            // specsFormatted: parsedData.specs_formatted,
            // ownerIdType: parsedData.owner_type,
            // ownerId: parsedData.owner_id,
            // registrationDate:
            //   parsedData.registration_date === "N/A" ||
            //   !parsedData.registration_date
            //     ? null
            //     : parsedData.registration_date,
            // omv: parsedData.omv,
            // arf: parsedData.arf,
            // coe: parsedData.coe,
            // coeExpiryDate: parsedData.coe_expiry_date,
            // vehicleNumber: parsedData.product_vehicle_number,
            // vehicleUnitNumber: parsedData.product_vehicle_unit_number,
            // vehicleReferenceNumber: parsedData.product_reference_number,
            // vehicleRegistrationCardNumber:
            //   parsedData.product_vehicle_registration_card_number,
            // cityName: parsedData?.product_pickup_location?.city,
            // regionName: parsedData?.product_pickup_location?.region_name,
            // address: parsedData?.product_pickup_location?.street,
            // isOffPeak: parsedData.is_off_peak_car,
            // deregValue: parsedData.dereg_value,
            // depreciationValue: parsedData.depreciation_value,
            // specsFormatted: parsedData.specs_formatted,
            // noOfBidding: parsedData.no_of_bidding,
          });

          // setSaleAdvisers(parsedData?.advertisement_contact_details.agents);
          let defaultAgents = [];
          if (parsedData?.advertisement_contact_details?.agents) {
            defaultAgents =
              parsedData?.advertisement_contact_details?.agents?.filter(
                (item) => item && item?.fullName && item?.fullName !== "",
              );
          }
          let sortingAgents = [];
          defaultAgents.map((item, i) => {
            let findAgent = parsedData?.product_agents?.filter(
              (agent) => agent && agent?.fullName == item.fullName,
            );
            sortingAgents.push({
              fullName: item.fullName,
              contactNumber: item.contactNumber,
              sorting: findAgent.length > 0 ? findAgent[0].sorting : i + 1,
            });
          });
          setSaleAdvisers(sortingAgents);

          setIsLoading(false);
        }
      })
      .catch((e) => console.log(e));
  };

  const getDealers = () => {
    setDealers({ ...dealers, loading: true });
    const pagination = {
      page: 1,
      limit: 100000,
      keyword: "",
      // roleIds: roles.filter((el)=>roleNames.includes(el.name)).map((el)=>el._id),
      roleIds: ["619e5d55e7040000a2007b08", "619e5d67e7040000a2007b09"],
      isVerified: true,
    };

    const users = fetchUsers(pagination);
    users
      .then((res) => {
        if (res.data.success) {
          setDealers({ ...dealers, loading: false, data: res.data.data });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const getCities = () => {
    setCities({ ...cities, loading: true });
    const onGetCities = fetchCities();
    onGetCities
      .then((res) => {
        if (res.data.success) {
          setCities({ ...cities, loading: false, data: res.data.data });
          if (isEdit) {
            res.data.data.forEach((city) => {
              setForm({ ...form, cityId: city._id });
            });
          }
        }
      })
      .catch((e) => console.log(e));
  };
  const getDistricts = () => {
    const onGetDistricts = fetchDistricts(form.city);
    onGetDistricts
      .then((res) => {
        if (res.data.success) {
          setDistricts({ ...districts, loading: false, data: res.data.data });
        }
      })
      .catch((e) => console.log(e));
  };
  const getBrands = () => {
    const pagination = {
      page: 1,
      limit: 10000,
    };
    setBrands({ ...brands, loading: true });
    const onGetBrands = fetchBrands(pagination);
    onGetBrands
      .then((res) => {
        if (res.data.success) {
          setBrands({ ...brands, loading: false, data: res.data.data });
        }
      })
      .catch((e) => console.log(e));
  };

  const getModels = () => {
    const onGetModels = fetchModels(form.carBrand);
    onGetModels
      .then((res) => {
        if (res.data.success) {
          setModels({ ...models, loading: false, data: res.data.data });
        }
      })
      .catch((e) => console.log(e));
  };

  const getPackages = () => {
    const packageType = "new";
    const packages = fetchPackages(packageType);
    packages
      .then((res) => {
        if (res.data.success) {
          setPackages(res.data.data);
        }
      })
      .catch((e) => console.log(e));
  };

  return (
    <div className="form-table-container">
      <div className={`table-title-icon ${!isEdit ? "add" : "edit"}`}>
        <IoMdAddCircleOutline />
      </div>
      <p className={`table-title-text ${!isEdit ? "add" : "edit"}`}>
        {!isEdit ? "Add New Car" : `Edit New Car`}
      </p>

      <div className="form-body-container">
        <Tabs size="large">
          <TabPane tab="Car Details Form" key="1">
            <NewCarDetails
              form={form}
              setForm={setForm}
              cities={cities}
              districts={districts}
              brands={brands}
              models={models}
              dealers={dealers}
              packages={packages}
              isEdit={isEdit}
              newCarVehicleTypes={newCarVehicleTypes}
              fuelTypes={fuelTypes}
              ownerIdTypes={ownerIdTypes}
              newCarConditions={newCarConditions}
              selectedFile1={selectedFile1}
              setSelectedFile1={setSelectedFile1}
              saleAdvisers={saleAdvisers}
            />
          </TabPane>
          <TabPane
            tab="Specifications"
            key="2"
            disabled={!validateNewProductForm(form)}
          >
            <Specifications
              form={form}
              specifications={form.specifications}
              setForm={setForm}
              isEdit={isEdit}
              fuelTypes={fuelTypes}
            />
          </TabPane>
          <TabPane
            tab="Equipments"
            key="3"
            disabled={!validateNewProductForm(form)}
          >
            <Equipments
              form={form}
              equipments={form.equipments}
              setForm={setForm}
              isEdit={isEdit}
            />
          </TabPane>
          <TabPane
            tab="Upload Images"
            key="4"
            disabled={!validateNewProductForm(form)}
          >
            <UploadCarImages
              isEdit={isEdit}
              form={form}
              setForm={setForm}
              selectedFiles={selectedFiles}
              setSelectedFiles={setSelectedFiles}
              urlsHolder={urlsHolder}
              setUrlsHolder={setUrlsHolder}
            />
          </TabPane>
          <TabPane
            tab="Car Ad Preview"
            key="5"
            disabled={
              !validateNewProductForm(form) ||
              !validateUpload(selectedFiles, form.imageUrls)
            }
          >
            <PreviewNewCar
              isEdit={isEdit}
              form={form}
              selectedFiles={selectedFiles}
              selectedFile1={selectedFile1}
              // selectedFile2={selectedFile2}
            />
          </TabPane>
        </Tabs>
      </div>
    </div>
  );
};

export default NewCarFormIndex;
